import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import TruckResultsComponents from "./truckResulst/truckResultsComponents.vue";
import FilterTruckComponent from "./filter/filterTruckComponent.vue";
import { TruckTypeFilter } from "@/store/modules/newOrders/type";
import { SeoDescription, SeoTitle } from "@/utils/seo/seo";
import { computed, onBeforeMount, ref, watch } from "vue";
import { IStore } from "@/store/types/StoreType";
import { getDataSearch } from "../fetch/getData";
import { useForm } from "vee-validate";
import { useStore } from "vuex";
import { CARS, IResultSearchStore } from "@/store/modules/Search/type";


export default /*#__PURE__*/_defineComponent({
  __name: 'truckComponent',
  setup(__props) {

const store = useStore<IStore>();
const initialValues = ref<TruckTypeFilter>(
  store.getters.getInitialValuesTruckNewOrders
);

const { handleSubmit, handleReset, resetForm } = useForm<TruckTypeFilter>({
  initialValues,
  validationSchema: {},
});

const resetFormTruck = () => {
  resetForm();
  store.commit("clearInitialValuesTruckNewOrders");
};

const onSubmit = handleSubmit((values) => getDataSearch(values));
const truckSearchResults = ref<IResultSearchStore<CARS>>(
  store.getters.getSearchTruck
);
watch(
  () => store.getters.getSelectedCurrency,
  () => {
    truckSearchResults.value.results.length > 0 &&
    handleSubmit((values) => getDataSearch(values, true))();
  }
);

onBeforeMount(() => {
  store.commit("updateSelectOrdersStateSelectFilter", "Truck");
  switch (uiLang.value.toUpperCase()) {
    case "SWEDISH":
      SeoTitle("Tyre point: Kuorma-auto");
      SeoDescription(
        "Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa."
      );
      break;
    case "FINLAND":
      SeoTitle("Tyre point: Tilaukset");
      SeoDescription(
        "Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa."
      );
      break;
    default:
      SeoTitle("Tyre point: Truck");
      SeoDescription(
        "The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe."
      );
      break;
  }
});
const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));
watch(
  () => uiLang.value,
  () => {
    switch (uiLang.value.toUpperCase()) {
      case "SWEDISH":
        SeoTitle("Tyre point: Kuorma-auto");
        SeoDescription(
          "Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa."
        );
        break;
      case "FINLAND":
        SeoTitle("Tyre point: Tilaukset");
        SeoDescription(
          "Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa."
        );
        break;
      default:
        SeoTitle("Tyre point: Truck");
        SeoDescription(
          "The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe."
        );
        break;
    }
  },
  {
    deep: true,
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onReset: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(handleReset) && _unref(handleReset)(...args))),
    onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
    class: "d-flex direction-column a-i-center filter-form-new_orders"
  }, [
    _createVNode(FilterTruckComponent, { resetForm: resetFormTruck }),
    _createVNode(TruckResultsComponents)
  ], 32))
}
}

})